export const ANNOUNCEMENTS = [
  // {
  //   key: "announcement_first_stand_v1",
  //   title: "FIRST STAND PRIZE",
  //   message: "Win the First Stand Tournament to claim this limited 1 of 1 G2 Caps from the First Stand 2026 Collection!",
  //   image: "/KK.png",
  //   image2: "/players/g2_caps_fs_preview.png",
  //   path: "/dashboard/league/",
  //   showCard: true,
  // },
  // {
  //   key: "announcement_first_stand_v2",
  //   title: "",
  //   message: "",
  //   image: "/first-stand-mobile-promo.webp",
  //   imageStyle: {
  //     maxWidth: "100%",
  //     maxHeight: "545px",
  //     objectFit: "contain"
  //   },
  //   image2: "",
  //   showCard: false,
  // },
];
